import { NestedHome } from '@habity/types';
import { randomInt } from '@habity/utils';

// Pick 1 random spot out of every N (spread)
// Generated indexes are 0-based, consistent with javascript
export function generatePromotionalHomeIndexes(
  numIndexesToGenerate: number,
  spread = 6
) {
  const indexes: number[] = [];

  if (numIndexesToGenerate <= 0 || spread < 3) return indexes;

  for (let i = 0; i < numIndexesToGenerate; i++) {
    const start = i * spread;
    const end = start + spread;
    indexes.push(randomInt(start, end));
  }

  return indexes;
}

export function interlacePromotionalHomes(
  homes: NestedHome[],
  promotionalHomes: NestedHome[],
  promotionalIndexes: number[]
): NestedHome[] {
  if (!promotionalHomes.length) return homes;

  const interlacedArray: NestedHome[] = [...homes];
  const deduplicatedPromotionalHomes = promotionalHomes.filter(ph => !homes.map(h => h.id).includes(ph.id));

  // Insert promotional homes at the predetermined indexes
  promotionalIndexes.forEach((promoIndex, i) => {
    const promoHome = deduplicatedPromotionalHomes[i];

    // Check to make sure we've not gone out of bounds of the array
    if (promoHome) {
      // If promoIndex is larger than the array, just place it at the end
      const insertIndex = Math.min(promoIndex, interlacedArray.length);
      interlacedArray.splice(insertIndex, 0, promoHome);
    }
  });

  return interlacedArray;
}
